/**
 * created by xcc
 * 视频编辑组件
 */
import React, {Component} from 'react';
class VideoEdit extends Component {

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const {videoUrl, videoName, videoEditCallback} = this.props;
        return (
            <>
                <a type={'link'}
                   style={{border: 'none', marginLeft: 32, color: "#0050B3", fontSize: 14}}
                   onClick={() => {
                       let that = this;
                       window.editer.editSuccessCallBack = function (obj) {
                           videoEditCallback(obj)
                       };
                       window.editer.open(videoUrl, videoName);
                   }}
                >视频编辑</a>
            </>
        )
    }
}

VideoEdit.propTypes = {};

export default VideoEdit;
